import { colorsPalettes } from "@similarweb/styles";
import { useTracking } from "@similarweb/tracking-provider";
import { Flex, Text, TruncatedText } from "@similarweb/ui-components/foundations";

import { CardLayout } from "../common/card-layout/CardLayout";
import { OpenInNewTab } from "../common/OpenInNewTab";

import type { WebsiteContentAlertItem } from "./useWebsiteContentAlertsQuery";

interface IWebsiteContentAlertProps {
    content: WebsiteContentAlertItem;
    favicon: string;
}

export const WebsiteContentAlert = ({ content, favicon }: IWebsiteContentAlertProps) => {
    const { track } = useTracking();
    const handleClick = () => {
        track("Alert Card", "click", "open alert/alerts/website-content");
        window.open(content.url, "_blank", "noopener,noreferrer");
    };

    return (
        <CardLayout
            iconUrl={favicon}
            onClick={handleClick}
            data-automation="website-content-alert"
            data-domain={content.domain}
        >
            <CardLayout.Header>
                <CardLayout.Title>
                    {content.domain}: {content.headline}
                </CardLayout.Title>
                <Text
                    flexShrink={0}
                    fontVariant="subtitle1"
                    color={colorsPalettes.carbon[250]}
                >
                    {content.formattedDate}
                </Text>
                <OpenInNewTab
                    url={content.url}
                    data-automation="website-content-external-link"
                />
            </CardLayout.Header>
            {content.content ? (
                <CardLayout.Content>
                    <Flex maxWidth="650px">
                        <TruncatedText
                            fontVariant="body2"
                            lineClamp={2}
                            data-automation="alert-description"
                        >
                            {content.content}
                        </TruncatedText>
                    </Flex>
                </CardLayout.Content>
            ) : null}
        </CardLayout>
    );
};
